import { getCookie } from 'legacy/utilities/Auth';

export default function useUsercode() {
	return getCookie('dmUsercode');
}
